const databaseUrl = "https://ltlpo.ngrok.io/api/";
const testUrl = "http://localhost:5005/api/"

export default databaseUrl;
